import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Battery(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props} viewBox='0 0 32 19'>
      <path
        d='M26.9728 18.7719H2.57394C1.15291 18.7719 0 17.619 0 16.198V3.1674C0 1.73297 1.16632 0.56665 2.60075 0.56665H26.9728C28.3938 0.56665 29.5467 1.71956 29.5467 3.14059V4.10582H31.075C31.5978 4.10582 32.0134 4.5214 32.0134 5.04424V14.3077C32.0134 14.8306 31.5978 15.2462 31.075 15.2462H29.5467V16.2114C29.5467 17.6324 28.3938 18.7853 26.9728 18.7853V18.7719ZM2.60075 2.44348C2.19858 2.44348 1.87683 2.76523 1.87683 3.1674V16.198C1.87683 16.5868 2.18517 16.8951 2.57394 16.8951H26.9728C27.3481 16.8951 27.6699 16.5868 27.6699 16.198V14.2943C27.6699 13.7715 28.0855 13.3559 28.6083 13.3559H30.1366V5.96925H28.6083C28.0855 5.96925 27.6699 5.55366 27.6699 5.03083V3.12719C27.6699 2.75182 27.3615 2.43008 26.9862 2.43008H2.60075V2.44348Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
